import React, { FunctionComponent } from "react";
import { MessageType } from "../../enums.generated";
import { Message } from "../../models/app";

const getAlertCssClass = (type: MessageType) => {
	let cssClass = "alert ";
	switch (type) {
		case MessageType.Error:
			cssClass += "alert-danger";
			break;
		case MessageType.Success:
			cssClass += "alert-success";
			break;
		case MessageType.Warning:
			cssClass += "alert-warning";
			break;
		default:
			cssClass += "alert-info";
			break;
	}
	return cssClass;
}

/**
 * Alert function component, outputs a bootstrap alert element.
 * @param props Alert props containing alert type and text.
 */
export const Alert: FunctionComponent<{ options: Message }> = (props: { options: Message }) => {

	const messageType = props.options.type ?? MessageType.Info;

	return (
		<div className={getAlertCssClass(messageType)} role="alert">
			{props.options.text}
		</div>
	)
}